export default [
  {
    id: 'contents',
    label: 'Conteúdo',
    active: true,
    childs: [
      {
        id: 'banners',
        label: 'Banners',
        link: '/list-banners',
        active: true,
      },
      {
        id: 'lives',
        label: 'Lives',
        link: '/lives',
        active: true,
      },
      {
        id: 'programs',
        label: 'Programas',
        link: '/programs',
        active: true,
      },
      {
        id: 'captions',
        label: 'Legendas',
        link: '/captions',
        active: true,
      },
      {
        id: 'modals',
        label: 'Modais',
        link: '/modal-management',
        active: true,
      },
    ],
  },
  {
    id: 'dashboard',
    label: 'Dashboard',
    active: true,
    childs: [
      {
        id: 'transactions',
        label: 'Transações',
        link: '/transactions',
        active: true,
      },
    ],
  },
  {
    id: 'links',
    label: 'Links',
    active: true,
    childs: [
      {
        id: 'linkShortner',
        label: 'Encurtador de links',
        link: '/link-shortner',
        active: true,
      },
      {
        id: 'linkGenerator',
        label: 'Gerador de links',
        link: '/link-generator',
        active: true,
      },
      {
        id: 'modalRedirect',
        label: 'Modal Redirect',
        link: '/modal-redirect',
        active: true,
      },
    ],
  },
  {
    id: 'createPartership',
    label: 'Parceiros',
    link: '/partnership',
    active: true,
  },
  {
    id: 'pushNotification',
    label: 'Push Notification',
    link: '/push-notifications',
    active: true,
  },
];
